module.exports = __webpack_public_path__ + "media/images/pt/energize_action-3f0a94a03f47eae22b10b22039246dc9.png";